import { render, staticRenderFns } from "./OpenChatView.vue?vue&type=template&id=4a486358&"
import script from "./OpenChatView.vue?vue&type=script&lang=js&"
export * from "./OpenChatView.vue?vue&type=script&lang=js&"
import style0 from "./OpenChatView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports